import React, { useCallback } from "react";
import PropTypes from "prop-types";
import SelectTimeEstimate from "~/components/component.select_time_estimate.jsx";

const TimeEstimatesPanel = ({ estimate, jobTypeId, handleChange, canEdit, isSplit, target }) => {
  const handleInternalChange = useCallback(
    ({ estimate, job_type_id }) => {
      if (typeof handleChange === "function") {
        handleChange(estimate, job_type_id);
      }
    },
    [handleChange]
  );

  return (
    <SelectTimeEstimate
      estimate={estimate}
      jobTypeId={jobTypeId}
      onChange={handleInternalChange}
      disabled={!canEdit}
      isSplit={isSplit}
      target={target}
    />
  );
};

TimeEstimatesPanel.propTypes = {
  estimate: PropTypes.string,
  jobTypeId: PropTypes.number,
  handleChange: PropTypes.func,
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  canEdit: PropTypes.bool,
  isSplit: PropTypes.bool,
  target: PropTypes.node,
};

TimeEstimatesPanel.defaultProps = {
  tabIndex: `-1`,
  handleChange: () => null,
  canEdit: true,
  loggedUserIsClient: false,
};

export default TimeEstimatesPanel;
